import Alert from '@mui/material/Alert';
import StaffMemberInformationCard from '../../../../../../components/StaffMemberInformation/StaffMemberInformationCard';
import styles from '../../../ReviewEmployeeAccess.module.scss';

/**
 * staffMembers: StaffMember[]
 */
const SubmissionSummary = ({ staffMembers }) => {
	return (
		<div>
			<Alert severity='success' className={styles.margin_top_small}>
				Successfully submitted Access Validation for{' '}
				{staffMembers.length} employees
			</Alert>
			{staffMembers.map(staffMember => {
				return (
					<div
						className={styles.margin_top_small}
						key={staffMember.esoFiId}
					>
						<StaffMemberInformationCard staffMember={staffMember} />
					</div>
				);
			})}
		</div>
	);
};

export default SubmissionSummary;
